import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./index.css";
import getProductLink from "../../../getProductLink";
import Fulfilment from "../../../../Fulfilment";
import ProductHero from "../../../../ProductHero";
import ProductTitle from "../../../../ProductTitle";
import getAriaLabelledBy from "../../../getAriaLabelledBy";
import { ACCESS_LEVEL_PURCHASE } from "../../../../../../../constants";
import webContextProvider from "../../../../../../../providers/webContextProvider";
import generateOneLinkURL from "./oneLinkGenerator";
import content from "app-content";

const ProductTile = ({
  ProductTileControls,
  ProductPriceComponents,
  ProductTileBadges = () => null,
  productId,
  title,
  variantId,
  ctaRef,
  isForceDisabled,
  source,
  seller,
  showShippedByMessage,
  earlyAccess,
  ...rest
}) => {
  const showAppDownloadButton =
    earlyAccess?.customerAccess === ACCESS_LEVEL_PURCHASE;
  const labels = getAriaLabelledBy({ productId, variantId });
  const webContext = webContextProvider();
  const generatedUrl = generateOneLinkURL(webContext, productId);

  return (
    <div className={styles.productTile} aria-hidden={isForceDisabled}>
      <div
        className={classNames(styles.nonControls, {
          [styles.appAdoption]: showAppDownloadButton
        })}
      >
        <a
          aria-labelledby={labels.labelledBy}
          href={getProductLink({ variantId, productId, ctaRef })}
        >
          <ProductHero {...{ variantId, labels, ...rest }} />
          <ProductTitle labelledById={labels.title} title={title} />
          <ProductPriceComponents
            labelledById={labels.price}
            discountLabelledById={labels.discount}
            variantId={variantId}
            {...rest}
          />
        </a>
        <ProductTileBadges {...{ ...labels, earlyAccess, ...rest }} />
        <Fulfilment
          labelledById={labels.fulfilment}
          source={source}
          seller={seller}
          productId={productId}
          variantId={variantId}
          showShippedByMessage={showShippedByMessage}
        />
      </div>
      {showAppDownloadButton ? (
        <>
          <a
            className={styles.appDownloadButton}
            href={
              webContext.platform === "mobile"
                ? generatedUrl
                : "https://www.asos.com/discover/our-apps/"
            }
          >
            {content.download_the_app_cta_title}
          </a>
          <p className={styles.appAdoptionDescription}>
            {content.pdp_banner_only_on_app_message}
          </p>
        </>
      ) : (
        <ProductTileControls
          productId={productId}
          variantId={variantId}
          isForceDisabled={isForceDisabled}
          seller={seller}
          source={source}
          title={title}
          {...rest}
        />
      )}
    </div>
  );
};

ProductTile.propTypes = {
  ProductTileControls: PropTypes.elementType.isRequired,
  ProductPriceComponents: PropTypes.elementType.isRequired,
  ProductTileBadges: PropTypes.elementType,
  productId: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  variantId: PropTypes.number,
  ctaRef: PropTypes.string.isRequired,
  isForceDisabled: PropTypes.bool.isRequired,
  source: PropTypes.shape({
    description: PropTypes.string.isRequired
  }),
  seller: PropTypes.shape({
    description: PropTypes.string.isRequired
  }),
  showShippedByMessage: PropTypes.bool,
  earlyAccess: PropTypes.shape({
    customerAccess: PropTypes.string
  })
};

export default ProductTile;
